import React from 'react';
import PropTypes from 'prop-types';
import s from './BrandwireComments.scss';

class BrandwireCommentItem extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      showMore: false,
    };
  }

  showMoreToggle = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  getCommentHtml() {
    const obj = this.props.commentsData;
    let html = '';
    let dataType;
    if (obj.Times_C === '1') {
      dataType = 'timesview';
    } else if (obj.Add_C === '1' && obj.Pre_C === '0' && obj.Re_C === '0') {
      dataType = 'addendum';
    } else if (obj.Add_C === '0' && obj.Pre_C === '1' && obj.Re_C === '0') {
      dataType = 'comment';
    } else if (obj.Add_C === '0' && obj.Pre_C === '0' && obj.Re_C === '1') {
      dataType = 'rebbutal';
    }

    const characters = `${unescape(
      obj.C_T.replace(/amp;/g, '')
        .replace(/&lt;br\/&gt;/g, '<br/>')
        .replace(/&lt;br \/&gt;/g, '<br/>'),
    )}`;

    const showMore = characters.length > 100 && !this.props.isWapView;

    const commentHtml = (
      <div
        className={`${s.brandwire} ${dataType ? s[dataType] : ''} ${
          dataType === 'rebuttal' || dataType === 'comment'
            ? s.brandwire_comment
            : ''
        }`}
      >
        <div className={s.brand_container}>
          {dataType === 'comment' && (
            <>
              {obj.N_I &&
                obj.N_I.length > 0 && (
                  <div className={s.brandwire_img}>
                    <img src={obj.N_I} alt="" />
                  </div>
                )}
              <div className={s.brandwire_title}>{obj.N_T}</div>
              <div className={s.container}>
                <div className={s.brandwire_date}>{obj.C_D}</div>
                <div className={s.brandwire_verified}>&radic; Verified</div>
                <div className={s.brandwire_content}>
                  {showMore && (
                    <>
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: characters.substr(0, 100),
                          }}
                        />
                        {!this.state.showMore && (
                          <span
                            className={s.moreellipses}
                            style={{ display: 'inline' }}
                          >
                            ...&nbsp;
                          </span>
                        )}
                        <span className={s.morecontent}>
                          {this.state.showMore && (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: characters.substr(
                                  100,
                                  characters.length,
                                ),
                              }}
                            />
                          )}
                        </span>
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className={s.morelink}
                        onClick={() => this.showMoreToggle()}
                      >
                        {this.state.showMore ? 'Less' : 'See more'}
                      </div>
                    </>
                  )}
                  {!showMore && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: characters,
                      }}
                    />
                  )}
                </div>
              </div>
            </>
          )}

          {dataType !== 'comment' && (
            <>
              <div className={s.brandwire_title}>{obj.N_T}</div>

              {dataType === 'rebuttal' && (
                <div className={s.brandwire_verified}>&radic; Verified</div>
              )}
              <div className={s.brand_container}>
                {obj.N_I &&
                  obj.N_I.length > 0 && (
                    <div className={s.brandwire_img}>
                      <img src={obj.N_I} alt="" />
                    </div>
                  )}
                <div className={s.brandwire_content}>
                  {showMore && (
                    <>
                      <div>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: characters.substr(0, 100),
                          }}
                        />
                        {!this.state.showMore && (
                          <span
                            className={s.moreellipses}
                            style={{ display: 'inline' }}
                          >
                            ...&nbsp;
                          </span>
                        )}
                        <span className={s.morecontent}>
                          {this.state.showMore && (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: characters.substr(
                                  100,
                                  characters.length,
                                ),
                              }}
                            />
                          )}
                        </span>
                      </div>
                      &nbsp;&nbsp;
                      <div
                        className={s.morelink}
                        onClick={() => this.showMoreToggle()}
                      >
                        {this.state.showMore ? 'Less' : 'See more'}
                      </div>
                    </>
                  )}
                  {!showMore && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: characters,
                      }}
                    />
                  )}
                </div>
                <div className={s.brandwire_date}>{obj.C_D}</div>
              </div>
            </>
          )}
        </div>
      </div>
    );

    html = (
      <>
        {dataType !== 'addendum' && commentHtml}
        {dataType === 'addendum' && (
          <div className={s.brandwire_response}>{commentHtml}</div>
        )}
      </>
    );

    return html;
  }

  render() {
    return this.getCommentHtml();
  }
}

BrandwireCommentItem.propTypes = {
  commentsData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool.isRequired,
};

BrandwireCommentItem.defaultProps = {};

export default BrandwireCommentItem;
